<app-header></app-header>

<main>
  <app-breadcrumb></app-breadcrumb>

  <div class="container position-relative">
    <div class="sidebar" [ngClass]="collapsed ? 'sidebar-collapsed' : ''">
      <app-app-aside
        (collapesChange)="handleToggleCollapseEvent($event)"></app-app-aside>
    </div>
    <div class="main-content" [ngClass]="getBodyClass()">
      <router-outlet></router-outlet>
    </div>
  </div>
</main>

<app-footer></app-footer>
